import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { ArquivoContratoService } from 'src/app/services/arquivo-contrato.service';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

@Component({
  selector: 'app-variaveis-arquivo-contrato-modal',
  templateUrl: './variaveis-arquivo-contrato-modal.component.html',
  styleUrls: ['./variaveis-arquivo-contrato-modal.component.scss']
})
export class VariaveisArquivoContratoModalComponent implements OnInit {
  variaveis = [];

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    private dialogRef: MatDialogRef<VariaveisArquivoContratoModalComponent>,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private arquivoContratoService: ArquivoContratoService
  ) { }

  ngOnInit(): void {
    this.buscarVariaveis();
  }

  buscarVariaveis() {
    this.carregandoService.mostra('buscarVariaveis');

    this.arquivoContratoService.consultarVariaveis().subscribe(
      (variaveis) => {
        this.variaveis = variaveis;
        this.carregandoService.esconde('buscarVariaveis');
      },
      (erro) => {
        this.carregandoService.esconde('buscarVariaveis');
        this.notificacaoService.erro(erro);
      }
    );

  }

  fechar() {
    this.dialogRef.close();
  }

}
